/*/////
//INIT
/////*/

function onloadFunctions () {

  var allElements = document.querySelectorAll('*');
  
  for ( let i = 0; i < allElements.length; i++) {
    allElements[i].style.transition = 'none';
  }

  changeHeaderColors.change();

  window.setTimeout( () => { 
    window.scrollTo(0,1);

    for ( let i = 0; i < allElements.length; i++) {
      allElements[i].style.transition = '';
    }

    changeHeaderColors.change();

  }, 500);

}


function onresizeFunctions () {

  /*disableTransitionsOnResize();*/

  /*document.getElementById('res').innerHTML = window.innerWidth + 'px / ' +  window.innerHeight + 'px / ' +  Math.ceil(window.innerWidth / window.innerHeight * 100) / 100;*/

}


function onStopScrolling () {

}


function onScrollFunctions () {

  changeHeaderColors.change();
  storeTransitions.animate();
  if ( typeof showHideLang == 'function' ) showHideLang();

}

function onKeydownFunctions (key) {
}

//RUN

window.addEventListener('load', onloadFunctions);//document. DOMContentLoaded
window.addEventListener('resize', onresizeFunctions);
window.addEventListener('scroll', onScrollFunctions);
window.addEventListener('keydown', onKeydownFunctions);